import { burn, } from "./burn";
import { isNativeToken, } from "./isNativeToken";
import type { AmountString, BlockHash, } from "@bracket/types";
import type { TokenIdentifier, } from "@bracket/types";

export declare type RedeemProps = {
	token: TokenIdentifier;
	amount: AmountString;
	brkt: AmountString;
};

export declare type RedeemResult = {
  hash: BlockHash;
  error: undefined;
} | {
  hash: null;
  error: Error;
};


/**
 * Redeems a token by burning it to receive the underlying collateral
 * 
 * @param {Object} props - The redeem operation parameters
 * @param {TokenIdentifier} props.token - The token to redeem
 * @param {AmountString} props.amount - The amount to redeem
 * @returns {Promise<RedeemResult>} Result containing transaction hash or error
 * @throws {Error} If attempting to redeem a native token
 */
export const redeem = async ({
	token,
	amount,
  brkt,
}: RedeemProps): Promise<RedeemResult> => {

  if(isNativeToken(token)) {
    return {
      hash: null,
      error: new Error("Native tokens cannot be redeemed"),
    }
  }

  return burn({ token, amount, brkt, });
};